export { default } from './ChatView';
export { default as template } from './chat-view.tpl';
